import React from 'react';
import { motion } from 'framer-motion';
export function Hook() {
  return <section className="py-20 px-6 bg-brand-bg-alt" data-id="element-430">
      <div className="max-w-[700px] mx-auto text-left" data-id="element-431">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl font-bold text-white mb-8 leading-tight" data-id="element-432">
          El problema no es tu edad. Es el estilo de vida ejecutivo moderno
          destruyendo tu energía sin que te des cuenta.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-6 text-[18px] text-[#E0E0E0] leading-[1.8]" data-id="element-433">
          <p data-id="element-434">
            Pantallas hasta tarde, estrés sostenido, mala hidratación, comidas
            improvisadas, sueño roto y dependencia de cafeína.
          </p>
          <p data-id="element-435">
            Si notas que tu rendimiento diario ha bajado, que el café ya no te
            da energía sino que solo te mantiene a flote, y que tu cuerpo
            acompaña cada vez menos tu ambición...
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-10 bg-brand-card border-l-4 border-brand-cyan rounded-xl p-6 shadow-lg" data-id="element-436">
          <p className="text-xl font-bold text-white leading-relaxed" data-id="element-437">
            BIO-X 90 ordena todo eso en un protocolo simple de 90 días.
          </p>
        </motion.div>
      </div>
    </section>;
}